import { useTranslation } from "react-i18next";

export default function WaaromWij() {
  const { t } = useTranslation("slotenmaker-eindhoven");
  const items = t("waarom.items", { returnObjects: true }) as Array<{
    title: string;
    text: string;
  }>;

  const icons = [
    "ri-time-line",
    "ri-shield-check-line",
    "ri-award-line",
    "ri-map-pin-line",
    "ri-shield-user-line",
  ];

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight mb-6 md:mb-8">
          {t("waarom.h2")}
        </h2>
        <p className="font-geist text-base md:text-lg text-brand-text/70 max-w-[900px] mb-10 md:mb-14 leading-relaxed">
          {t("waarom.intro")}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-brand-cream rounded-2xl p-6 md:p-8 border border-brand-border/60"
            >
              <div className="w-12 h-12 rounded-xl bg-brand-yellow/20 flex items-center justify-center mb-4">
                <i
                  className={`${icons[i]} w-6 h-6 flex items-center justify-center text-brand-text text-lg`}
                ></i>
              </div>
              <h3 className="font-geist font-bold text-lg text-brand-text mb-2">
                {item.title}
              </h3>
              <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}